import { render, staticRenderFns } from "./QRCodeReader.vue?vue&type=template&id=3914a39f&scoped=true&"
import script from "./QRCodeReader.vue?vue&type=script&lang=js&"
export * from "./QRCodeReader.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeReader.vue?vue&type=style&index=0&id=3914a39f&prod&lang=css&"
import style1 from "./QRCodeReader.vue?vue&type=style&index=1&id=3914a39f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3914a39f",
  null
  
)

export default component.exports